
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function GalleryNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/85ac07f0-174f-4cb4-a03d-92c27ed718d4.png"
              alt="Logo"
              className="h-12 w-auto"
            />
          </Link>
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              Home
            </Link>
            <Link
              to="/gallery/the-olivian-on-4th"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname.includes('olivian')
                  ? (isScrolled ? 'text-teal-600' : 'text-teal-300')
                  : (isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300')
              }`}
            >
              The Olivian on 4th
            </Link>
            <Link
              to="/gallery/the-honey-bee"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname.includes('honey')
                  ? (isScrolled ? 'text-teal-600' : 'text-teal-300')
                  : (isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300')
              }`}
            >
              The Honey Bee
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
